module.exports = __webpack_public_path__ + "static/integrations-desktop-89d4a671285b30e8f1c27ab62494c497.png";